export const canDeclareBuyerPayment = (
    settledDateTime: string | null,
    invoiceAmountTTC: number,
    partialAmountPaidByBuyer: number
) =>
    !settledDateTime && (invoiceAmountTTC - partialAmountPaidByBuyer > 0);
